import React from 'react';

const AppContext = React.createContext({
  authenticated: false,
  setAuthenticated: () => {},
});

export default AppContext;
